<template>
  <div id="produtos-cadastrados-30-dias" class="w3-container w3-margin-top" style="padding: 0;">

    <div class="w3-col s12 m12 l12" v-if="processando">
      <div class="w3-panel w3-theme w3-card-2">
        <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
      </div>
    </div>

    <div v-if="!processando" class="w3-margin-bottom">
      <input 
        type="text" 
        v-model="filtro_produtos"
        v-on:keyup="filtrarProdutos()"
        class="w3-input w3-border w3-padding margin-bottom-filtro"
        placeholder="Pesquise por código ou nome do produto">

      <label>Empresa</label>
      <select 
        @click="mudarPagina(0)"
        v-model="empresa_selecionada_id"
        class="w3-input w3-border margin-bottom-filtro" 
        @change="buscarProdutosCadastrados30Dias()">
        <option 
          v-for="empresa in empresas_autorizadas" 
          :value="empresa.empresa_id"
          :key="empresa.empresa_id">
          {{`${empresa.empresa_id} - ${empresa.nome_fantasia}`}}
        </option>
      </select> 
        
      <label>Marca</label>
      <select 
        @click="mudarPagina(0)"
        v-model="filtro_marca" 
        class="w3-input w3-border margin-bottom-filtro">
        <option value="">Selecione uma marca</option>
        <option 
          v-for="(marca, marca_index) in marcas" 
          :key="marca_index"
          :value="marca.marca">
          {{marca.marca}}
        </option>
      </select>
    </div>

    <div
      class="w3-panel w3-text-theme w3-bottombar w3-border-theme w3-border w3-animate-left"
      v-if="(Object.keys(produtos_filtrados).length === 0) && !processando" 
      v-cloak>
      
      <div class="w3-container w3-white">
        <p>Não há produtos a serem exibidos.</p>
      </div>
    </div>

    <div 
      class="wrapper-componente" 
      v-if="(Object.keys(produtos_filtrados).length > 0) && !processando">
      
      <div 
        class="card-item w3-container" 
        v-for="(produto, produto_index) in novosProdutosFiltrados" 
        :key="produto_index">
        
        <div class="w3-col s12">
          <strong class="w3-text-theme"><i class="fas fa-box"></i>&nbsp;{{produto.produto_id}} - {{produto.nome}} - {{produto.unidade}}</strong>
        </div>
        
        <div class="w3-col s12 m3 l4">
          <label>Marca: </label>
          <strong>{{produto.marca}}</strong>
        </div>
      
        <div class="w3-col s12">
          <label>Estoque da Loja: </label>
          <strong>{{produto.estoque_loja}}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Estoque da Rede: </label>
          <strong>{{produto.estoque_rede}}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Quantidade Dias: </label>
          <strong>{{produto.quantidade_dias}}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Preço Venda: </label>
          <strong>R$ {{ nPadraoReais(produto.preco_venda) }}</strong>
        </div>
      
      </div>

      <paginacao 
        @pagina="mudarPagina"
        :pagina-atual="paginaAtual"
        itens-por-pagina="10" 
        :total-resultados="totalResultados"
        :total-de-paginas="totalDePaginas" />
    </div>
  </div>
</template>

<script>
  import store from '@/ambiente/store';
  import Paginacao from '@/components/Paginacao'
  import Biblioteca from '@/components/Repositorio/Biblioteca';
  import RProdutoBuscarProdutosCadastradosUltimos30DiasDashboard from '@/components/Rest/RProduto/RProdutoBuscarProdutosCadastradosUltimos30DiasDashboard'
  
  export default {
    name: 'ProdutosCadastrados30Dias',

    components: {
      Paginacao
    },

    data() {
      return {
        api: process.env.API,
        empresas_autorizadas: [],
        empresa_selecionada_id: 0,
        produtos_cadastrados_filtrados: [],
        qtd_produtos_cadastrados_30_dias: 0,
        processando: false,
        filtro_produtos: '',
        produtos_filtrados: [],
        filtro_marca: '',
        paginaAtual: 0,
        itensPorPagina: 10,
        totalResultados: 0,
        totalDePaginas: 0,
      }
    },

    mounted() {
      $('html,body').stop().animate(
        {scrollTop: 0}, 
        'slow', 
        'swing'
      );
    },

    methods: {
      mudarPagina(numeroDaPagina) {
        this.paginaAtual = numeroDaPagina;
      },

      filtrarProdutos() {
        this.produtos_filtrados = [];
        this.mudarPagina(0);

        if (this.filtro_produtos == '') {
          this.produtos_filtrados = this.produtos_cadastrados_filtrados;
          return;
        }

        this.filtro_produtos = this.filtro_produtos.toUpperCase();
        for (let i = 0; i < this.produtos_cadastrados_filtrados.length; i++) {
          if (this.produtos_cadastrados_filtrados[i].nome.toUpperCase().indexOf(this.filtro_produtos) > -1) {
            this.produtos_filtrados.push(this.produtos_cadastrados_filtrados[i]);
          }

          if (this.produtos_cadastrados_filtrados[i].produto_id.replace(".", "").indexOf(this.filtro_produtos) > -1) {
            this.produtos_filtrados.push(this.produtos_cadastrados_filtrados[i]);
          }
        }
      },

      limparResultados(){
        this.paginaAtual = 0;
        this.itensPorPagina = 10;
        this.totalResultados = 0;
        this.totalDePaginas = 0;
        this.produtos_filtrados = [];
        this.produtos_cadastrados_filtrados = [];
        this.confirmarQtdProdutoCadastrado30Dias(0);
      },

      async buscarQuantidadeTotalProdutosCadastrados30Dias(){       
        this.confirmarQtdProdutoCadastrado30Dias(this.qtd_produtos_cadastrados_30_dias);  
      },

      confirmarQtdProdutoCadastrado30Dias(qtd_produtos){
        this.$emit(
          'quantidade_produto_cadastrado_30_dias', 
          {quant_produto: qtd_produtos}
        );
      },

      async buscarProdutosCadastrados30Dias() {
        try {
          this.processando = true;
          this.limparResultados();

          let parametros = {
            empresa_id: this.empresa_selecionada_id 
          }

          let retorno = await RProdutoBuscarProdutosCadastradosUltimos30DiasDashboard.buscarProdutosCadastradosUltimos30DiasDashboard(this.axios, parametros);
          if (retorno.houve_erro != 'N'){
            throw new Error(retorno.mensagem);
          }

          if (retorno.dados) {
            this.produtos_cadastrados_filtrados = JSON.parse(JSON.stringify(retorno.dados));
            this.produtos_filtrados = JSON.parse(JSON.stringify(retorno.dados));
            this.confirmarQtdProdutoCadastrado30Dias(this.produtos_cadastrados_filtrados.length);
          }
          
          this.processando = false;
        } 
        catch (error) {
          this.processando = false;
          Biblioteca.exclamar(error.message);
        }
      },

      nPadraoReais(valor){
        return Biblioteca.nPadraoReais(valor);
      },
    },

    async created() {
      this.empresas_autorizadas = JSON.parse(JSON.stringify(await store.state.empresas_autorizadas));
      this.empresa_selecionada_id = await store.state.empresa_logada.empresa_id;
      await this.buscarProdutosCadastrados30Dias();

      this.qtd_produtos_cadastrados_30_dias = 0;
      if (this.produtos_cadastrados_filtrados){
        this.qtd_produtos_cadastrados_30_dias = this.produtos_cadastrados_filtrados.length;
      }
    },

    computed: {
      marcas() {
        let produtos_lista_filtrada = this.produtos_filtrados;

        let lista_marcas = produtos_lista_filtrada.filter((thing, index, self) =>
          index === self.findIndex((t) => (
            t.marca === thing.marca
          ))
        );

        lista_marcas.sort(function(a, b) {
          let textA = a.marca.toUpperCase();
          let textB = b.marca.toUpperCase();
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });

        return lista_marcas;
      },
      
      formatarValor: function(valor, quant_casas_decimais = 3){
        let formatter = new Intl.NumberFormat('pt-BR', {
          minimumFractionDigits: quant_casas_decimais,
          maximumFractionDigits: quant_casas_decimais
        });

        return formatter.format(valor);
      },

      novosProdutosFiltrados() {
        let produtos_lista_filtrada = this.produtos_filtrados;
        
        if (this.filtro_marca) {
          produtos_lista_filtrada = produtos_lista_filtrada.filter(obj => {
            return obj.marca === this.filtro_marca
          })
        };
        
        this.totalResultados = produtos_lista_filtrada.length;
        this.totalDePaginas =  Math.ceil(this.totalResultados / 10);

        if(this.paginaAtual >= this.totalDePaginas) { 
          this.paginaAtual = this.totalDePaginas;
        };

        let index = this.paginaAtual * 10;
        return produtos_lista_filtrada.slice(index, index + 10);
      }
    }
  }
</script>

<style scoped>
  .card-item {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/ProdutosCadastrados30Dias.vue